export default __webpack_public_path__ + "c65e8eacdc3b16c89ded085cd17756d5.svg";